<div fxLayout="row" fxLayoutAlign="center start" fxFlexFill>
    <div fxFlex="50" fxLayout="row" fxLayoutAlign="start start" class="left-container" style="height: 100vh; background-image: url('assets/images/loginimg.png'); background-size: cover; background-position: top left; position: relative;">
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="center center" style="padding: 50px; color: white; width: 100%; max-width: 800px; margin: 0 auto;">
            <div fxLayout="column" fxLayout.gt-md="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                <img src="assets/images/loginlogo.png" alt="" style="width: 200px; max-width: 100%;">
                <div fxHide fxShow.gt-md style="width: 1px; height: 70px; background-color: white;"></div>
                <span [ngStyle]="{'margin': '20px 0 0 0', 'font-size': '24px', 'line-height': '1.5rem', 'text-align': 'center', 'max-width': '400px'}" fxFlex.gt-md>Process Management System for Corporate Mobile Assets</span>
            </div>
        </div>
    </div>
    <div fxFlex="50" fxLayoutAlign="center start" style="padding-top: 15%;">
        <div fxFlex="95" style="background: none; box-shadow: none; border: none;" [ngStyle]="{'max-width': '600px', 'padding': '0 2rem'}">
            <h2 fxLayoutAlign="start" style="font-size: 40px; font-weight: 600; margin-bottom: 4rem;">Sign In</h2>
            <form fxLayoutAlign="stretch" fxLayout="column" [formGroup]="formGroup" (ngSubmit)="loginProcess()">
                <mat-form-field style="font-size: 16px; margin-bottom: 1rem;"> 
                    <input matInput placeholder="Username/Email Address" formControlName="username" style="font-size: 16px;">  
                </mat-form-field>
                
                <mat-form-field style="font-size: 16px; margin-bottom: 1rem;">
                    <input matInput type="password" placeholder="Password" formControlName="password" style="font-size: 16px;">         
                </mat-form-field>
                <!-- <re-captcha
                    (resolved)="resolved($event)"
                    siteKey="6LeXxrMmAAAAABQ9uSJyixj87hNJ3pDwW3clVSXm"
                ></re-captcha> -->

                <button mat-raised-button color="primary" type="submit" style="">CONTINUE</button>
            </form>
        </div>
    </div>
</div>